import { render, staticRenderFns } from "./SimuladorOdontoModal.vue?vue&type=template&id=93bab8e0&scoped=true"
import script from "./SimuladorOdontoModal.vue?vue&type=script&lang=js"
export * from "./SimuladorOdontoModal.vue?vue&type=script&lang=js"
import style0 from "./SimuladorOdontoModal.vue?vue&type=style&index=0&id=93bab8e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bab8e0",
  null
  
)

export default component.exports